import { FirebaseError } from "firebase/app";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export class HostAuthenticator {
  private auth = getAuth();

  get isAuthenticated() {
    return getAuth().currentUser?.isAnonymous === false;
  }

  async signIn(email: string, password: string) {
    try {
      const credentials = await signInWithEmailAndPassword(this.auth, email, password);

      return {
        success: true,
        userId: credentials.user.uid,
      } as const;
    } catch (error) {
      if (error instanceof FirebaseError && error.code.startsWith("auth/")) {
        return {
          success: false,
          code: error.code,
        } as const;
      } else {
        console.error("An unknown error occurred while signing in");
        console.error(error);

        return {
          success: false,
          code: "unknown",
        } as const;
      }
    }
  }

  subscribeToAuthentication(callback: (userId: string | null) => void) {
    return this.auth.onAuthStateChanged((user) => {
      callback(user?.uid ?? null);
    });
  }

  async getCurrentHostId() {
    await getAuth().authStateReady();
    return getAuth().currentUser?.uid ?? null;
  }
}
